module.exports = __webpack_public_path__ + "static/img/logo_01.44bb1c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_01.png
// module id = WWJl
// module chunks = 1